import type { Components, Theme } from '@mui/material/styles';

export const MuiTableRow: Components<Theme>['MuiTableRow'] = {
	styleOverrides: {
		root: {
			'&:last-child td': {
				borderBottom: 'none',
			},
			'&.MuiTableRow-hover:hover td': {
				backgroundColor: 'var(--surface-hover)',
			},
			'&.Mui-selected td, &.Mui-selected:hover td': {
				backgroundColor: 'var(--accent-surface)',
			},
			'&:focus-visible': {
				outline: '2px solid var(--focus)',
				outlineOffset: -2,
			},
		},
	},
};
